module.exports = __webpack_public_path__ + "static/img/Dyson_Heppell_desktop.b47a153.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Dyson_Heppell_desktop.jpg
// module id = 6Pm1
// module chunks = 0